import { __assign, __rest } from "tslib";
/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Menu.Subcomponent` filename
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Menu.Panel.scss';
var MENU_PANEL_CLASS = 'MenuPanel';
var MenuPanel = function (_a) {
    var children = _a.children, className = _a.className, onClose = _a.onClose, shouldAutoFocus = _a.shouldAutoFocus, props = __rest(_a, ["children", "className", "onClose", "shouldAutoFocus"]);
    var menuRef = useRef(null);
    var handleDocumentKeyDown = function (event) {
        if (event.key === 'Escape') {
            onClose();
        }
    };
    var handleDocumentClick = function (_a) {
        var target = _a.target;
        var isClickInMenu = target.closest(".".concat(MENU_PANEL_CLASS));
        if (!isClickInMenu) {
            onClose();
        }
    };
    useEffect(function () {
        var _a;
        if (shouldAutoFocus) {
            // NB: React's `autoFocus` prop cannot be used on divs, so we must focus manually
            (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        document.addEventListener('click', handleDocumentClick);
        document.addEventListener('keydown', handleDocumentKeyDown);
        return function () {
            document.removeEventListener('click', handleDocumentClick);
            document.removeEventListener('keydown', handleDocumentKeyDown);
        };
    });
    var menuClassName = classnames(MENU_PANEL_CLASS, className);
    return (React.createElement("div", __assign({}, props, { className: menuClassName, ref: menuRef, role: 'menu', 
        // enables focus to be set on a div via JS, but not by the user
        tabIndex: -1 }),
        React.createElement("div", { className: 'MenuPanel__content' }, children)));
};
MenuPanel.defaultProps = {
    shouldAutoFocus: false
};
MenuPanel.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func,
    shouldAutoFocus: PropTypes.bool
};
export default MenuPanel;
//# sourceMappingURL=Menu.Panel.js.map